<input #myFileInput2 style="display: none;" type="file" (click)="myFileInput2.value=null"
  (change)="fileChangeEvent($event, profilePhotoUpload)" accept="image/jpg, image/jpeg, image/png" />

<ng-template #candidateTemplate>
  <div class="common-header-flex">
    <div class="f-1">
      <div *ngIf="object?.status != 'ACTIVE'&&object?.status != 'DRAFTED'&&object?.status != 'AWAITING HOST'"> Make
        Candidate Available </div>
      <div *ngIf="object?.status == 'ACTIVE'||object?.status == 'DRAFTED'||object?.status == 'AWAITING HOST'"> Edit
        Candidate</div>
    </div>
    <div>
      <button>
        <span class="common-close" (click)="cancelcloseCandidate()">&times;</span>
      </button>
    </div>
  </div>

  <div class="panel-body  custom-modal-body">
    <form [formGroup]="candidatePostForm" action="">
      <div class="app-form pd-10">


        <div class="flecs"> 
          <div class="col-sm-3 griddd">
            <img *ngIf="fileshow==undefined && object?.photo!=undefined" src={{url+object?.photo}}
              class="candidate-image" alt="">
            <img *ngIf="fileshow!=undefined" src="{{fileshow}}" onerror="this.src='assets/images/userAvatar.png';"
              class="candidate-image" alt="">
            <div *ngIf="fileshow==undefined && object?.photo==undefined">
              <div class="circles candidate-image"
                [style.background-color]="getColorName(object?.firstName, object?.lastName)">
                <div class="circle-text-1">{{ getInitialName(object?.firstName,
                  object?.lastName) }}</div>
              </div>
            </div>

            <div>
              <button id="update-candidate-profile-photo" class="btn btn-primary paydd upload-button-908"  (click)="uploadPhotoHere()"> Upload Photo </button>
            </div>

            <div>
              <b *ngIf="candidatePostForm.value.candidateId != null">{{candidatePostForm.value.candidateId}}</b>
            </div>
          </div>
          <div class="col-sm-9">
            <div class="dropdox-908" appDnd (fileDropped)="onFileDropped($event)" for="fileDropRef" [ngClass]="{'uploading-disabled': isUploading}">
              <input style="display: none" accept=".pdf,.doc,.docx,.txt" type="file" #fileDropRef id="fileDropRef"
                (click)="fileDropRef.value=''"
                (change)="fileBrowseHandler($event.target.files)" [disabled]="isUploading" />

              <div class="file-icon-908">
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="12" y1="18" x2="12" y2="12"></line>
                  <line x1="9" y1="15" x2="15" y2="15"></line>
                </svg>
              </div>

              <div>
                <label for="fileDropRef" class="upload-title-908">Upload Your Resume</label>
              </div>

              <div>
                <label for="fileDropRef" class="upload-instruction-908">Drag your files here or click in this
                  area.</label>
              </div>

              <div>
                <small class="upload-hint-908">Only PDF, DOCX, DOC, and TXT file formats supported.</small>
              </div>

              <div *ngIf="fileDragdrop && !isUploading" class="file-preview-908 file-preview-entered-908">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                  stroke-linecap="round" stroke-linejoin="round">
                  <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
                  <polyline points="13 2 13 9 20 9"></polyline>
                </svg>
                <span class="file-name-908" [attr.title]="getUploadDisplayName(fileDragdrop)">{{getUploadDisplayName(fileDragdrop)}}</span>
                <!-- <span>{{fileDragdrop | json}}</span> -->
                <!-- <button class="file-remove-908">✕</button> -->
                <ng-icon name="tablerX" class="svg-position file-remove-908" (click)="removeFiles()"></ng-icon>
              </div>

              <!-- Upload Progress Bar -->
              <div *ngIf="isUploading" class="upload-progress-container-908">
                <div class="upload-progress-info-908">
                  <span class="uploading-text-908">Uploading...</span>
                  <span class="upload-percentage-908">{{uploadProgress}}%</span>
                </div>
                <div class="progress-bar-wrapper-908">
                  <div class="progress-bar-908" [style.width.%]="uploadProgress"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="files-list" *ngIf="fileDragdrop">
          <div class="single-file">
            <div class="file-icon" style="width: 50px"></div>
            <div class="info">
              <h4 class="name">
                {{ fileDragdrop?.name ? fileDragdrop.name : getFileName(fileDragdrop?.fileName) }}
              </h4>
              <p title="Download" class="cursor-pointer top-eye" (click)="onDownload()">
                <ng-icon name="tablerDownload" class="mr-rt-5" aria-hidden="true"></ng-icon>
              </p>
              <div title="Remove File" (click)="removeFiles()" class="tiimes">x</div>

            </div>
          </div>

        </div> -->



        <div class="col-sm-12 form-group">

          <div class="row">
            <div class="col-sm-6 pl-0" style="padding-bottom: 15px;">
              <label for="firstName" class="control-label required-field font-bold">First Name</label>
              <input type="text" class="form-control input-sm" maxlength="21" placeholder="First Name" id="firstName"
                formControlName="firstName" (keypress)="checkspace($event)">
              <div *ngIf="
             (candidateSubmit && candidateControls.firstName.invalid) ||
             (candidateControls.firstName.invalid &&
               (candidateControls.firstName.dirty ||
                 candidateControls.firstName.touched))  ">
                <div class="error-msg" *ngIf="candidateControls.firstName.errors.required">
                  First Name is required
                </div>
                <div class="error-msg w-wrap " *ngIf="candidateControls.firstName.errors?.minword">
                  {{FORMERROR.FIRSTNAME_MIN}}
                </div>
                <div class="error-msg w-wrap " *ngIf="candidateControls.firstName.errors?.maxword">
                  {{FORMERROR.FIRSTNAME_MAX}}
                </div>
                <div *ngIf="candidateControls.firstName.errors?.pattern && candidateControls.firstName.touched"
                  class="error-msg ps-init">
                  Enter valid first Name
                </div>
              </div>
            </div>

            <div class="col-sm-6 pr-0" style="padding-bottom: 15px;">
              <label for="lastName" class="control-label required-field font-bold">Last Name</label>
              <input type="text" class="form-control input-sm" maxlength="41" placeholder="Last Name" id="lastName"
                formControlName="lastName" (keypress)="checkspace($event)">
              <div *ngIf="
             (candidateSubmit && candidateControls.lastName.invalid) ||
             (candidateControls.lastName.invalid &&
               (candidateControls.lastName.dirty ||
                 candidateControls.lastName.touched))
           ">
                <div class="error-msg" *ngIf="candidateControls.lastName.errors.required">
                  Last Name is required
                </div>
                <div *ngIf="candidateControls.lastName.errors?.pattern && candidateControls.lastName.touched"
                  class="error-msg ps-init">
                  Enter valid Last Name
                </div>
                <div class="error-msg w-wrap " *ngIf="candidateControls.lastName.errors?.minword">
                  {{FORMERROR.LASTNAME_MIN}}
                </div>
                <div class="error-msg w-wrap " *ngIf="candidateControls.lastName.errors?.maxword">
                  {{FORMERROR.LASTNAME_MAX}}
                </div>
              </div>
            </div>
          </div>

          <div class="row">

            <div class="col-sm-6 pl-0" style="padding-bottom: 15px;">
              <label for="phone" class="control-label required-field font-bold">Phone</label>
              <input type="text" class="form-control input-sm" placeholder="Phone" id="phone" formControlName="phone"
                maxlength="16">

              <div *ngIf="candidateSubmit && (candidateControls.phone.touched || candidateControls.phone.invalid)"
                class="error-msg">
                <div *ngIf="candidateControls.phone.errors?.required">Phone Number is required.</div>
              </div>
              <div class="error-msg" *ngIf="candidateControls.phone.errors?.maxword">
                {{FORMERROR.PHONE_MAX}}
              </div>
              <div class="error-msg"
                *ngIf="candidateControls.phone.errors?.minword && !candidateControls.phone.errors?.pattern">
                {{FORMERROR.PHONE_MIN}}
              </div>
              <div class="error-msg"
                *ngIf="candidateControls.phone.errors?.pattern && !candidateControls.phone.errors?.maxword">
                {{FORMERROR.NUMBER_PATTERN}}
              </div>

            </div>

            <div class="col-sm-6 pr-0" style="padding-bottom: 15px;">
              <label for="clientName" class="control-label required-field  font-bold">Email ID</label>
              <input type="text" maxlength="51" class="form-control input-sm" (input)="patchEmail()"
                placeholder="Email ID" id="email" formControlName="email">
              <div *ngIf="
                (candidateSubmit && candidateControls.email.invalid) ||
                (candidateControls.email.invalid &&
                  (candidateControls.email.dirty ||
                    candidateControls.email.touched))
              " class="  w-wrap  ">
                <div class="error-msg" *ngIf="candidateControls.email.errors.existingEmailAddress">
                  This email address is taken
                </div>
                <div class="error-msg" *ngIf="candidateControls.email?.errors?.required">
                  Email ID is required
                </div>
                <div class="error-msg"
                  *ngIf=" candidateControls.email.errors.pattern && !candidateControls.email.errors.maxword">
                  {{FORMERROR.EMAIL_VALID}}
                </div>
                <div class="error-msg" *ngIf="candidateControls.email.errors.maxword">
                  {{FORMERROR.EMAIL_MAX}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6 pl-0" style="padding-bottom: 15px;">
              <label for="availableIn" class="control-label required-field font-bold">Availability</label>
              <select class="form-control input-sm" formControlName="availableIn" type="text"
                (change)="onChangePeriod($event.target.value)">
                <option value="null" selected disabled>Select One</option>
                <option *ngFor="let list of periodList" [value]="list">
                  {{list}}</option>
              </select>
              <div *ngIf="
                  (candidateSubmit && candidateControls.availableIn.invalid) ||
                  (candidateControls.availableIn.invalid &&
                    (candidateControls.availableIn.dirty ||
                      candidateControls.availableIn.touched))
                " class="error-msg">
                <div *ngIf="candidateControls.availableIn.errors.required">
                  Availablility is required
                </div>
              </div>
            </div>

            <div class="col-sm-6 pr-0" style="padding-bottom: 15px;">
              <label class="control-label required-field font-bold">Engagement Type</label>
              <select class="form-control input-sm" formControlName="engagementType" type="text"
                (change)="onEngagementTypeChange($event.target.value)">
                <option value="null" selected disabled>Select Your Engagement Type</option>
                <option *ngFor="let engagementType of engagementTypeList" [value]="engagementType">
                  {{engagementType}}</option>
              </select>
              <div *ngIf="
                  (candidateSubmit && candidateControls.engagementType.invalid) ||
                  (candidateControls.engagementType.invalid &&
                    (candidateControls.engagementType.dirty ||
                      candidateControls.engagementType.touched))
                " class="error-msg">
                <div *ngIf="candidateControls.engagementType.errors.required">
                  Engagement Type is required
                </div>
              </div>
              <!-- Corp-to-Corp info alert -->
              <div *ngIf="isCorpToCorp" class="alert alert-info mt-2 mb-0" style="font-size: 12px; padding: 8px 12px; border-radius: 4px;">
                <ng-icon name="tablerInfoCircle" style="margin-right: 6px;"></ng-icon>
                Corp-to-Corp engagement requires your company to have a supplier profile in the Contract Center for sub-contracted jobs. Ensure your organization is registered before applying to jobs.
              </div>
            </div>
          </div>

          <!-- Corp-to-Corp conditional fields -->
          <div class="row" *ngIf="isCorpToCorp">
            <div class="col-sm-6 pr-0" style="padding-bottom: 15px;">
              <label class="control-label required-field font-bold">Client Type</label>
              <select class="form-control input-sm" formControlName="clientType">
                <option value="null" selected disabled>Select Client Type</option>
                <option *ngFor="let ct of clientTypeList" [value]="ct">{{ct}}</option>
              </select>
              <div *ngIf="(candidateSubmit && candidateControls.clientType?.invalid) ||
                (candidateControls.clientType?.invalid && (candidateControls.clientType?.dirty || candidateControls.clientType?.touched))"
                class="error-msg">
                <div *ngIf="candidateControls.clientType?.errors?.required">Client Type is required</div>
              </div>
              <div class="form-check mt-1">
                <input type="checkbox" class="form-check-input" formControlName="showClientType" id="showClientType">
                <label class="form-check-label" for="showClientType" style="font-size: 12px; color: #718096;">Show Client Type on profile</label>
              </div>
            </div>
            <div class="col-sm-6" style="padding-bottom: 15px;">
              <label class="control-label required-field font-bold">Client Name</label>
              <input type="text" class="form-control input-sm" formControlName="clientName" placeholder="Enter client name">
              <div *ngIf="(candidateSubmit && candidateControls.clientName?.invalid) ||
                (candidateControls.clientName?.invalid && (candidateControls.clientName?.dirty || candidateControls.clientName?.touched))"
                class="error-msg">
                <div *ngIf="candidateControls.clientName?.errors?.required">Client Name is required</div>
              </div>
              <div class="form-check mt-1">
                <input type="checkbox" class="form-check-input" formControlName="showClientName" id="showClientName">
                <label class="form-check-label" for="showClientName" style="font-size: 12px; color: #718096;">Show Client Name on profile</label>
              </div>
            </div>
          </div>

        </div>
        <div class="row"> 
          <div class="col-sm-6" style="padding-bottom: 15px;">
            <label for="title" class="control-label required-field font-bold">Job Title</label>
            <div [attr.title]="selectedJobTitle">
              <ng-select class="multiselectlable gs-clear-plain" [inputAttrs]="{maxlength: '150'}" [items]="candidateJobTitleList" [addTag]="true"
                [hideSelected]="false" [clearable]="true" dropdownPosition="bottom" formControlName="jobTitle" [multiple]="false"
                placeholder="Job Title" [(ngModel)]="selectedJobTitle">
                <ng-template ng-option-tmp let-item="item">
                  <div class="custom-option multi-line-option" [attr.title]="item">
                    {{ item }}
                  </div>
                </ng-template>
                <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                  <div class="selected-item" [attr.title]="item">
                    <span class="ng-value-label">{{ item }}</span>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div *ngIf="
              (candidateSubmit && candidateControls.jobTitle.invalid) ||
              (candidateControls.jobTitle.invalid &&
                (candidateControls.jobTitle.dirty ||
                  candidateControls.jobTitle.touched))
            " class="error-msg">
              <div *ngIf="candidateControls.jobTitle.errors.required">
                Job Title is required
              </div>
              <div *ngIf="candidateControls.jobTitle.errors.minword">
                {{FORMERROR.JOBTITLE_MIN}}
              </div>
              <div *ngIf="candidateControls.jobTitle.errors.maxword">
                {{FORMERROR.JOBTITLE_MAX}}
              </div>
            </div>

          </div> 
            <div class="col-sm-6" style="padding-bottom: 15px;">
            <label for="totalExperience" class="control-label required-field font-bold">Total Experience</label>
            <select type="text" formControlName="totalExperience" class="form-control input-sm">
              <option value="null" disabled selected hidden>Select the number of years of experience</option>
              <option [value]="totalExperience" *ngFor="let totalExperience of totalExperienceList">
                {{totalExperience}}</option>
            </select>
            <div *ngIf="
                  (candidateSubmit && candidateControls.totalExperience.invalid) ||
                  (candidateControls.totalExperience.invalid &&
                    (candidateControls.totalExperience.dirty ||
                      candidateControls.totalExperience.touched))
                " class="error-msg">
              <div *ngIf="candidateControls.totalExperience.errors.required">
                Total Experience is required
              </div>
            </div>
          </div>  
        </div> 

        <div class="row">
          <div class="col-sm-12" style="padding-bottom: 20px;">
            <label for="location" class="control-label required-field font-bold">Current Location</label>
            <div class="row">
              <div class="col-sm-6" style="padding-bottom: 15px;">
                <select class="form-control input-sm" formControlName="country" type="text"
                  (change)="onChangeCountry($event.target.value, 'candidates')">
                  <option value="null" selected disabled>Country</option>
                  <option *ngFor="let country of countryList" [value]="country.countryCode">
                    {{country.countryName}}</option>
                </select>
                <div *ngIf="
                (candidateSubmit && candidateControls.country.invalid) ||
                (candidateControls.country.invalid &&
                  (candidateControls.country.dirty ||
                    candidateControls.country.touched))
              " class="error-msg">
                  <div *ngIf="candidateControls.country.errors.required">
                    Country is required
                  </div>
                </div>
              </div>

              <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='US'">
                <select class="form-control input-sm" formControlName="state" type="text">
                  <option value="null" selected=true disabled>State</option>
                  <option *ngFor="let state of usStatesList" [value]="state">{{state}}
                  </option>
                </select>
                <div *ngIf="
            (candidateSubmit && candidateControls.state.invalid) ||
            (candidateControls.state.invalid &&
              (candidateControls.state.dirty ||
                candidateControls.state.touched))
          " class="error-msg">
                  <div *ngIf="candidateControls.state.errors.required">
                    State is required
                  </div>
                </div>
              </div>

              <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='CA'">
                <select class="form-control input-sm" formControlName="state" type="text">
                  <option value="null" selected=true disabled>State</option>
                  <option *ngFor="let state of stateListCA" [value]="state.stateName">{{state.stateName}}
                  </option>
                </select>
                <div *ngIf="
            (candidateSubmit && candidateControls.state.invalid) ||
            (candidateControls.state.invalid &&
              (candidateControls.state.dirty ||
                candidateControls.state.touched))
          " class="error-msg">
                  <div *ngIf="candidateControls.state.errors.required">
                    State is required
                  </div>
                </div>
              </div>

              <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='IN'">
                <select class="form-control input-sm" formControlName="state" type="text">
                  <option value="null" selected=true disabled>State</option>
                  <option *ngFor="let state of stateListIN" [value]="state.stateName">{{state.stateName}}
                  </option>
                </select>
                <div *ngIf="
            (candidateSubmit && candidateControls.state.invalid) ||
            (candidateControls.state.invalid &&
              (candidateControls.state.dirty ||
                candidateControls.state.touched))
          " class="error-msg">
                  <div *ngIf="candidateControls.state.errors.required">
                    State is required
                  </div>
                </div>
              </div>

              <div class="col-sm-6" *ngIf="candidatePostForm.value.country=='AU'">
                <select class="form-control input-sm" formControlName="state" type="text">
                  <option value="null" selected=true disabled>State</option>
                  <option *ngFor="let state of stateListAU" [value]="state.stateName">{{state.stateName}}
                  </option>
                </select>
                <div *ngIf="
            (candidateSubmit && candidateControls.state.invalid) ||
            (candidateControls.state.invalid &&
              (candidateControls.state.dirty ||
                candidateControls.state.touched))
          " class="error-msg">
                  <div *ngIf="candidateControls.state.errors.required">
                    State is required
                  </div>
                </div>
              </div>

              <div class="col-sm-6" *ngIf="candidatePostForm.value.country!='AU'&&
                                                    candidatePostForm.value.country!='IN'&&
                                                    candidatePostForm.value.country!='CA'&&
                                                    candidatePostForm.value.country!='US'">
                <input type="text" maxlength="51" placeholder="State" formControlName="state"
                  class="form-control input-sm">
                <div *ngIf="
                (candidateSubmit && candidateControls.state.invalid) ||
                (candidateControls.state.invalid &&
                  (candidateControls.state.dirty ||
                    candidateControls.state.touched))
              " class="error-msg w-wrap">
                  <div *ngIf="candidateControls.state.errors.required">
                    State is required.
                  </div>
                  <div *ngIf="candidateControls.state.errors.maxword">
                    {{FORMERROR.STATE_MAX}}
                  </div>
                </div>
              </div>
            </div>

            <div class="row pt-16">
              <div class="col-sm-6">
                <input type="text" maxlength="51" placeholder="City" formControlName="city"
                  class="form-control input-sm">
                <div *ngIf="
                  (candidateSubmit && candidateControls.city.invalid) ||
                  (candidateControls.city.invalid &&
                    (candidateControls.city.dirty ||
                      candidateControls.city.touched))
                " class="error-msg w-wrap">
                  <div *ngIf="candidateControls.city.errors.required">
                    City is required
                  </div>
                  <div *ngIf="candidateControls.city.errors.maxword">
                    {{FORMERROR.CITY_MAX}}
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <input type="text" maxlength="12" placeholder="Zip Code" formControlName="zipCode"
                  class="form-control input-sm">
                <div *ngIf="
                    (candidateSubmit && candidateControls.zipCode.invalid) ||
                    (candidateControls.zipCode.invalid &&
                      (candidateControls.zipCode.dirty ||
                        candidateControls.zipCode.touched))
                  " class="error-msg">
                  <div *ngIf="candidateControls.zipCode.errors?.required">
                    Zipcode is required
                  </div>
                  <div class="w-wrap" *ngIf="candidateControls.zipCode.errors?.minword">
                    {{FORMERROR.ZIPCODE_MIN}}
                  </div>
                  <div class="w-wrap" *ngIf="candidateControls.zipCode.errors?.maxword">
                    {{FORMERROR.ZIPCODE_MAX}}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <!-- primary secondary skills  -->
        <div class="row" style="padding-bottom: 15px;">
          <div class="col-sm-12">
            <div class="col-sm-6 pl-0">
              <label for="primarySkills" class="control-label required-field font-bold">Primary Skills</label>
              <div>
                <ng-select class="multiselectlable" [items]="primarySkillsList" [addTag]="true" [hideSelected]="false"
                  dropdownPosition="bottom" formControlName="primarySkills" maxSelectedItems="3" [multiple]="true"
                  [closeOnSelect]="false" [clearSearchOnAdd]="true" placeholder="e.g. Java, Spring, Hibernate"
                  [(ngModel)]="primarySkillsSelected" (clear)="onSkillsCleared('primary')">

                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="ng-select-checkbox-label">
                      <span class="ng-select-checkmark" [class.checked]="item$.selected"
                        [class.disabled]="!item$.selected && primarySkillsSelected?.length==3"></span>
                      <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                    </div>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                    <div class="selected-item" [attr.title]="item">
                      <span class="ng-value-clear remove-icon" (click)="clear(item)">
                        ✕
                      </span>
                       
                      <span class="ng-value-label">{{ item }}</span>
                    </div>
                  </ng-template>
                </ng-select>
           
              </div>
              <small style="font-size: 12px;">Enter no more than 3</small>
              <div style="display:flex; float: right;">
                <div *ngIf="(candidateSubmit && candidateControls.primarySkills.invalid) ||
                    (candidateControls.primarySkills.invalid &&
                      (candidateControls.primarySkills.dirty ||
                        candidateControls.primarySkills.touched))" class="error-msg">
                    <div *ngIf="candidateControls.primarySkills.errors.required">
                      Primary Skills is required
                    </div>
                  </div>
              </div>
            </div>

            <div class="col-sm-6 pr-0">
              <label for="secondarySkills" class="control-label font-bold">Secondary
                Skills</label>
              <div>
                <ng-select class="multiselectlable" [items]="secondarySkillsList" [addTag]="true" [hideSelected]="false"
                  dropdownPosition="bottom" formControlName="secondarySkills" maxSelectedItems="3" [multiple]="true"
                  [closeOnSelect]="false" [clearSearchOnAdd]="true" placeholder="e.g. Java, Spring, Hibernate"
                  [(ngModel)]="secondarySkillsSelected" (clear)="onSkillsCleared('secondary')">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="ng-select-checkbox-label">
                      <span class="ng-select-checkmark" [class.checked]="item$.selected"
                        [class.disabled]="!item$.selected && secondarySkillsSelected?.length==3"></span>
                      <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                    </div>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                    <div class="selected-item" [attr.title]="item">
                      <span class="ng-value-clear remove-icon" (click)="clear(item)">
                        ✕
                      </span>
                       
                      <span class="ng-value-label">{{ item }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
              <small style="font-size: 12px;">Enter no more than 3</small>
            </div>
          </div>
        </div>

        <div class="col-sm-12 p-0" style="margin-bottom: 15px;">

          <div class="col-sm-6 pl-0">
            <label for="workAuthorization" class="control-label required-field font-bold">Work
              Authorization</label>
            <select [disabled]="workflag" class="form-control input-sm" formControlName="workAuthorization" type="text">
              <option value="null" selected disabled>Select Work Authorization</option>
              <option *ngFor="let workAuthorization of workAuthorizationList" [value]="workAuthorization"
                [disabled]="workAuthorization?.length==0">
                {{workAuthorization}} </option>
            </select>
            <div *ngIf="
                (candidateSubmit && candidateControls.workAuthorization.invalid) ||
                (candidateControls.workAuthorization.invalid &&
                  (candidateControls.workAuthorization.dirty ||
                    candidateControls.workAuthorization.touched))
              " class="error-msg">
              <div *ngIf="candidateControls.workAuthorization.errors.required">
                Work Authorization is required
              </div>
            </div>
          </div>

          <div class="col-sm-6 pr-0">
            <label for="payType" class="control-label required-field font-bold">Pay Type</label>
            <select (change)="onChangePayType($event.target.value, 'candidates')" type="text" formControlName="payType"
              class="form-control input-sm">
              <option [selected]=true [value]=null disabled>Select Pay Type</option>
              <option [value]="list" *ngFor="let list of payTypeList">{{list}}</option>
            </select>
            <div *ngIf="
                        (candidateSubmit && candidateControls.payType.invalid) ||
                        (candidateControls.payType.invalid &&
                          (candidateControls.payType.dirty ||
                            candidateControls.payType.touched))
                      " class="error-msg w-wrap">
              <div *ngIf="candidateControls.payType.errors.required">
                Pay Type is required
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 p-0">
          <label for="targetRateFrom" class="control-label required-field font-bold">Target Rate
            Range</label>
        </div>
        <div class="col-sm-12 p-0" style="margin-bottom: 15px;">
          <div class="col-sm-6 pl-0">
            <div>
              <input type="text" maxlength="9" class="form-control input-sm"
                (keyup)="onTargetRateTyped($event.target.value,'candidates')" placeholder="From" id="targetRate"
                (keypress)="decimalFilter($event)" formControlName="targetRateFrom">
              <div class="input-group-append">
                <span class="input-group-text currency-type-1">
                  <label *ngIf="candidatePostForm.value.country=='US' || candidatePostForm.value.country == null"
                    for="USD" class="currency-type pt-7">USD</label>
                  <label *ngIf="candidatePostForm.value.country=='IN'" for="INR" class="currency-type pt-7">INR</label>
                  <label *ngIf="candidatePostForm.value.country=='CA'" for="CAD" class="currency-type pt-7">CAD</label>
                  <label *ngIf="candidatePostForm.value.country=='AU'" for="AUD" class="currency-type pt-7">AUD</label>
                  <label
                    *ngIf="candidatePostForm.value.country!='US' && candidatePostForm.value.country!='IN' && candidatePostForm.value.country!='CA' && candidatePostForm.value.country!='AU' && candidatePostForm.value.country!=null"
                    for="CUR" class="currency-type pt-7">CUR</label>
                </span>
              </div>
            </div>
            <div *ngIf="
                                      (candidateSubmit && candidateControls.targetRateFrom.invalid) ||
                                      (candidateControls.targetRateFrom.invalid &&
                                        (candidateControls.targetRateFrom.dirty ||
                                          candidateControls.targetRateFrom.touched))
                                    " class="error-msg">
              <div class="edit-tar-len" *ngIf="candidateControls?.targetRateFrom?.errors?.required">
                Target Rate is required
              </div>

              <div class="w-wrap" *ngIf="candidateControls?.targetRateFrom?.errors?.minword">
                {{FORMERROR.TARGETRATE_MIN}}
              </div>
              <div *ngIf="candidateControls?.targetRateFrom?.errors?.maxword">
                {{FORMERROR.TARGETRATE_MAX}}
              </div>

              <div style="padding-left: 9px;"
                *ngIf="candidateControls.targetRateFrom.errors?.invalidDecimal&& !candidateControls?.targetRateFrom?.errors?.maxword">
                {{FORMERROR.TARGETRATE_PATTERN}}
              </div>
            </div>
          </div>

          <div class="col-sm-6 pr-0">
            <div>
              <input type="text" (keyup)="onTargetRateTyped($event.target.value,'candidates')" maxlength="9"
                class="form-control input-sm" placeholder="To" id="targetRate" (keypress)="decimalFilter($event)"
                formControlName="targetRateTo">
              <div class="input-group-append">
                <span class="input-group-text currency-type-2">
                  <label *ngIf="candidatePostForm.value.country=='US' || candidatePostForm.value.country == null"
                    for="USD" class="currency-type pt-7">USD</label>
                  <label *ngIf="candidatePostForm.value.country=='IN'" for="INR" class="currency-type pt-7">INR</label>
                  <label *ngIf="candidatePostForm.value.country=='CA'" for="CAD" class="currency-type pt-7">CAD</label>
                  <label *ngIf="candidatePostForm.value.country=='AU'" for="AUD" class="currency-type pt-7">AUD</label>
                  <label
                    *ngIf="candidatePostForm.value.country!='US' && candidatePostForm.value.country!='IN' && candidatePostForm.value.country!='CA' && candidatePostForm.value.country!='AU' && candidatePostForm.value.country!=null"
                    for="CUR" class="currency-type pt-7">CUR</label>
                </span>
              </div>
            </div>
            <div *ngIf="
                                      (candidateSubmit ) ||
                                      (
                                        (candidateControls.targetRateTo.dirty ||
                                          candidateControls.targetRateTo.touched))
                                    " class="error-msg">
              <div class="edit-tar-len" *ngIf="candidateControls?.targetRateTo?.errors?.required">
                Target Rate is required
              </div>
              <div class="w-wrap"
                *ngIf="candidatePostForm.errors && candidatePostForm?.errors?.rangevalidation&&!candidateControls.targetRateFrom.errors?.invalidDecimal">
                Invalid target rate range</div>

              <div class="w-wrap" *ngIf="candidateControls?.targetRateTo?.errors?.minword">
                {{FORMERROR.TARGETRATE_MIN}}
              </div>
              <div *ngIf="candidateControls?.targetRateTo?.errors?.maxword">
                {{FORMERROR.TARGETRATE_MAX}}
              </div>

              <div style="padding-left: 9px;"
                *ngIf="candidateControls.targetRateTo.errors?.invalidDecimal&& !candidateControls?.targetRateTo?.errors?.maxword">
                {{FORMERROR.TARGETRATE_PATTERN}}
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 p-0" style="margin-bottom: 15px;">
          <div class="col-sm-6 pl-0">
            <label for="workMode" class="control-label required-field font-bold">Work Mode</label>
            <select class="form-control input-sm" formControlName="workMode" type="text">
              <option [value]="null" disabled>Select Your Work Mode</option>
              <option value="Onsite">Onsite</option>
              <option value="Remote">Remote</option>
              <option value="Hybrid">Hybrid</option>
            </select>
            <div *ngIf="
                                     (candidateSubmit && candidateControls.workMode.invalid) ||
                                     (candidateControls.workMode.invalid &&
                                     (candidateControls.workMode.dirty ||
                                     candidateControls.workMode.touched))  " class="error-msg">
              <div *ngIf="candidateControls.workMode.errors.required">
                Work Mode is required
              </div>
            </div>
          </div>

          <div class="col-sm-6 pr-0">
            <label class="control-label required-field font-bold">Publish To</label>
            <ng-select class="multiselectlable" [items]="networkGroups" bindLabel="name" bindValue="id"
              placeholder="Select networks" [multiple]="true" [closeOnSelect]="false" [(ngModel)]="selectedNetworks"
              formControlName="selectedNetworks" (change)="onNetworkSelectionChange(candidatePostForm)">

              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <ng-container *ngIf="item.type">

                  <ng-container *ngIf="index === 0 || networkGroups[index - 1].type !== item.type">
                    <div class="networktype">{{ item.type }}</div>
                  </ng-container>

                  <div class="ng-select-checkbox-label networkname"
                    [class.marketplace-locked]="(membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1'"
                    [class.permission-disabled]="item.disabled">
                    <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                    <ng-icon name="tablerBan" style="font-size:10px;margin-right:4px;color:#e53e3e;" *ngIf="item.disabled"></ng-icon>
                    <span class="ng-select-checkbox-text" [attr.title]="item.name">{{ item.name }}</span>
                  </div>
                </ng-container>
              </ng-template>
              <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                <div class="selected-item" [attr.title]="item.name">
                  <ng-icon name="tablerBan" style="margin-right:4px;font-size:10px;color:#b0b0b0;" *ngIf="item.disabled"></ng-icon>
                  <ng-icon name="tablerLock" style="margin-right:4px;font-size:10px;color:#8B5CF6;" *ngIf="!item.disabled && isNetworkLocked(item.id)"></ng-icon>
                  <span class="ng-value-clear remove-icon" (click)="clear(item)"
                    *ngIf="!item.disabled && !isNetworkLocked(item.id) && !((membershipType === 'Free' || userType === 'JOB_SEEKER') && item.id === '1')">
                    ✕
                  </span>
                  <span class="ng-value-label">{{ item.name }}</span>
                </div>
              </ng-template>
            </ng-select>
            <div *ngIf="
                        (candidateSubmit && candidateControls.selectedNetworks.invalid) ||
                        (candidateControls.selectedNetworks.invalid &&
                          (candidateControls.selectedNetworks.dirty ||
                          candidateControls.selectedNetworks.touched))
                      " class="error-msg">
              <div *ngIf="candidateControls.selectedNetworks.errors.required">
                Publish to is required
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 p-0">
          <div class="col-sm-6 pl-0" style="padding-bottom: 15px;">
            <div class="preferred-states-row"
              [class.preferred-states-row--active]="candidatePostForm.value.otherPrefered == true">
              <div class="custom-checkbox preferred-states-row__check">
                <label class="checkbox-label font-bold w-wrap"> Other
                  Preferred States
                  <input type="checkbox" name="otherPrefered" formControlName="otherPrefered" (change)="onOtherPreferedChange($event)">
                  <span class="checkmark" title="You can check or uncheck this to show or hide client type"></span>
                </label>
              </div>
              <div class="preferred-states-row__select"
                *ngIf="candidatePostForm.value.otherPrefered == true">
                <ng-select class="multiselectlable" [items]="otherStatesList"
                  [addTag]="true" [hideSelected]="false" dropdownPosition="bottom"
                  [(ngModel)]="otherSelectedStates" formControlName="otherPreferedStates" [multiple]="true"
                  [closeOnSelect]="false" [clearSearchOnAdd]="true" placeholder="Select states">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="ng-select-checkbox-label">
                      <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                      <span class="ng-select-checkbox-text" [attr.title]="item">{{item}}</span>
                    </div>
                  </ng-template>
                  <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
                    <div class="selected-item" [attr.title]="item">
                      <span class="ng-value-clear remove-icon" (click)="clear(item)">
                        ✕
                      </span>
                       
                      <span class="ng-value-label">{{ item }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </div>
          <div class="col-sm-6 pr-0" style="padding-bottom: 15px;">
            <div class="security-clearance-card"
              [class.active]="candidatePostForm.get('securityClearance')?.value">
              <div class="security-clearance-card__info">
                <div class="security-clearance-card__icon">
                  <ng-icon name="tablerShieldLock"></ng-icon>
                </div>
                <div class="security-clearance-card__text">
                  <span class="security-clearance-card__title">Security Clearance</span>
                </div>
              </div>
              <div class="security-clearance-card__action">
                <span class="security-clearance-card__status"
                  [class.active]="candidatePostForm.get('securityClearance')?.value">
                  {{ candidatePostForm.get('securityClearance')?.value ? 'Yes' : 'No' }}
                </span>
                <label class="platform-toggle-switch">
                  <input type="checkbox" formControlName="securityClearance" name="securityClearance">
                  <span class="platform-toggle-track">
                    <span class="platform-toggle-thumb"></span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="userType!='JOB_SEEKER'" class="col-sm-12 p-0" style="padding-bottom: 15px;">
          <div class="platform-profile-toggle-group">
            <div class="platform-profile-card"
              [class.active]="candidatePostForm.get('createCandidateOnPlatform')?.value">
              <div class="platform-profile-card__info">
                <div class="platform-profile-card__icon">
                  <ng-icon name="tablerUserPlus"></ng-icon>
                </div>
                <div class="platform-profile-card__text">
                  <span class="platform-profile-card__title">Create Candidate Profile on the Platform</span>
                  <span class="platform-profile-card__desc">Publish this candidate to GigSumo so recruiters can
                    discover and engage them directly.</span>
                </div>
              </div>
              <div class="platform-profile-card__action">
                <span class="platform-profile-card__status"
                  [class.active]="candidatePostForm.get('createCandidateOnPlatform')?.value">
                  {{ candidatePostForm.get('createCandidateOnPlatform')?.value ? 'Yes' : 'No' }}
                </span>
                <label class="platform-toggle-switch">
                  <input type="checkbox" name="createCandidateOnPlatform"
                    (click)="createCandidateOnProf($event)" formControlName="createCandidateOnPlatform">
                  <span class="platform-toggle-track">
                    <span class="platform-toggle-thumb"></span>
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <div class="row">
            <!-- resume summmary  -->
            <div class="col-sm-12 R-summary">
              <label class="control-label required-field font-bold">Resume Summary</label>
              <div formControlName="resumeSummary" [ngxSummernote]="config2" class="note-editor.note-frame"></div>
              <div *ngIf="
            (candidateSubmit && candidateControls.resumeSummary.invalid) ||
            (candidateControls.resumeSummary.invalid &&
              (candidateControls.resumeSummary.dirty ||
                candidateControls.resumeSummary.touched))
          " class="error-msg">
                <div *ngIf="candidateControls.resumeSummary.errors.required">
                  Resume Summary is required
                </div>
                <div *ngIf="candidateControls.resumeSummary.errors.minChar">
                  Resume summary should at least have {{ RESUME_SUMMARY.min }} Characters
                </div>
                <div *ngIf="candidateControls.resumeSummary.errors.maxChar">
                  Resume Summary can have a maximum of {{ RESUME_SUMMARY.max }} Characters.
                </div>
              </div>
              <small>Maximum of {{ RESUME_SUMMARY.max }} Characters allowed</small>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button [ngClass]="{'disabled': disable_for_draft==true}" class="btn btn-default"
          (click)="cancelcloseCandidate()">Cancel</button>
        <button class="btn  btn-primary" type="submit" *ngIf="object.status!='ACTIVE' &&object.status!='INACTIVE'"
          [ngClass]="{'disabled': disable_for_draft==true}" (click)="updateCandidate('DRAFTED')">Save as
          Draft</button>
        <button [ngClass]="{'disabled': disable_for_draft==true}" class="btn  btn-primary" type="submit"
          *ngIf="object.status!='DRAFTED'&& object.status=='ACTIVE'" (click)="updateCandidate('ACTIVE')">Update</button>
        <button [ngClass]="{'disabled': disable_for_draft==true}" class="btn  btn-primary" type="submit"
          *ngIf="(object.status=='DRAFTED'  || object.status=='INACTIVE')&& object.status!='ACTIVE'"
          (click)="updateCandidate('ACTIVE')">Update</button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #profilePhotoUpload>

  <div class="common-header-flex">
    <div>Profile Photo</div>
    <button><span class="common-close" (click)="closePhoto2()" aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 4"
      format="jpeg" (imageCropped)="imageCropped($event)" (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"></image-cropper>
  </div>


  <div class="modal-footer" style="border-radius: 5px !important;">
    <button class="btn btn-default m-r-18 w70" (click)="closePhoto2()">Cancel</button>
    <button class="btn primary-btn m-r-18 w70" (click)="imageLoaded2()">Apply</button>
  </div>

</ng-template>